var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3767 16.0664L9.37671 18.0664M9.37671 18.0664L11.3767 20.0664M9.37671 18.0664H18.3767C18.6953 18.05 19.0054 17.9576 19.281 17.7969C19.5566 17.6362 19.7898 17.412 19.9611 17.1428C20.1323 16.8737 20.2367 16.5674 20.2656 16.2497C20.2944 15.932 20.2468 15.612 20.1267 15.3164L19.5767 14.3164",
    stroke: "#E7FFE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91262 10.0665L7.18057 7.33447M7.18057 7.33447L4.44852 8.06652M7.18057 7.33447L2.68057 15.1287C2.53549 15.4128 2.46049 15.7276 2.46182 16.0466C2.46316 16.3656 2.5408 16.6797 2.68825 16.9626C2.8357 17.2455 3.04869 17.489 3.30944 17.6728C3.57019 17.8567 3.87113 17.9754 4.18714 18.0192L5.32816 18.0429",
    stroke: "#E7FFE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8408 10.0663L17.5729 10.7983M17.5729 10.7983L18.3049 8.06629M17.5729 10.7983L13.0729 3.00411C12.8993 2.7364 12.6643 2.51409 12.3873 2.35574C12.1104 2.19738 11.7996 2.10758 11.4808 2.09382C11.1621 2.08007 10.8447 2.14276 10.5551 2.27667C10.2656 2.41057 10.0122 2.61181 9.81628 2.86357L9.22526 3.83988",
    stroke: "#E7FFE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.626a0bd1d4141e8c38890df503a4028c.svg";
export { ForwardRef as ReactComponent };